import React, { Component } from 'react';
import $j from 'jquery';
import c from 'classnames';
import {
  AccentButton,
  Icon as IconComponent,
  TooltipPopup
} from '@lyearn-team/frontend-components';
import LiveClassMembersButton from 'components/LiveClass/model-views/LiveClassMembersButton';
import WindowScrollHandler from '../../../helper/WindowScrollHandler';
import Icon from '../../../../helper/Icon';
import * as s from './styles';

export default class CardInfo extends Component {
  componentDidMount() {
    this.scrollReacter = $j('.cardInfoInnerContainer');
    const heightAll = $j('.cardTopViewContainer').height();
    $j('#CardInternalContainer').css('padding-top', heightAll + 40);
    WindowScrollHandler.addCallbackObj(
      this.windowScrollCallback.bind(window, this),
      'learningSpaceTopView'
    );
    if (this.props.card.resource.type === 'scorm') {
      this.scrollReacter.addClass('minimizedTopView');
      setTimeout(() => {
        const height = $j('.cardTopViewContainer').height();
        $j('#CardInternalContainer').css('padding-top', height + 40);
      }, 400);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.card.name !== this.props.card.name ||
        prevProps.isTimeBased !== this.props.isTimeBased ||
        prevProps.windowWidth !== this.props.windowWidth) &&
      this.props.card.resource.type !== 'scorm'
    ) {
      if (this.scrollReacter.hasClass('minimizedTopView')) {
        this.scrollReacter.removeClass('minimizedTopView');
        this.scrollReacter.one('transitionend', () => {
          const height = $j('.cardTopViewContainer').height();
          $j('#CardInternalContainer').css('padding-top', height + 40);
        });
      } else {
        const height = $j('.cardTopViewContainer').height();
        $j('#CardInternalContainer').css('padding-top', height + 40);
      }
    } else if (this.props.card.resource.type === 'scorm') {
      if (!this.scrollReacter.hasClass('minimizedTopView')) {
        this.scrollReacter.addClass('minimizedTopView');
        setTimeout(() => {
          const height = $j('.cardTopViewContainer').height();
          $j('#CardInternalContainer').css('padding-top', height + 40);
        }, 400);
      }
    }
  }

  componentWillUnmount() {
    WindowScrollHandler.removeCallbackObj('learningSpaceTopView');
  }

  windowScrollCallback = () => {
    if (window.pageYOffset > 100) {
      if (!this.scrollReacter.hasClass('minimizedTopView')) {
        this.scrollReacter.addClass('minimizedTopView');
      }
    } else if (this.props.card.resource.type !== 'scorm') {
      this.scrollReacter.removeClass('minimizedTopView');
    }
  };

  renderAssignmentControls = () => {
    if (
      this.props.card.resource.type === 'assignment' &&
      this.props.card.performance &&
      this.props.card.performance.completionStatus === 'COMPLETE' &&
      this.props.card.reAttemptAllowed &&
      !this.props.card.performance.forceComplete
    ) {
      return (
        <div className={s.editSubmission}>
          <AccentButton
            onClick={this.props.unSubmitClicked}
            text="Unsubmit & Edit"
            icon={{
              type: 'edit',
              style: { width: '14px', marginRight: '6px' }
            }}
          />
          <div style={{ marginLeft: '8px' }}>
            <TooltipPopup title="This will make your assessment incomplete. Submit again to complete.">
              <IconComponent type="info" style={{ padding: '8px 0', width: 16, height: 30 }} />
            </TooltipPopup>
          </div>
        </div>
      );
    }
    return null;
  };

  render() {
    const { isTimeBased, windowWidth, isLiveClass, course, card } = this.props;
    const { name, globalPosition } = card;
    const isMobile = windowWidth < 768;

    return (
      <div className={'CardInfoContainer' + (isTimeBased ? ' timeBased' : '')}>
        <div className={c('cardInfoInnerContainer', isLiveClass ? s.liveClassCard : '')}>
          {/* !isMobile && <LiveClassMembersButton className="liveClassMembersButton" /> */}
          {isLiveClass ? <div className="hideOnScroll courseName">{course.name}</div> : null}
          <div className="hideOnScroll cardGlobalPosition">{`LESSON ${globalPosition}`}</div>
          <div className="flexRow">
            <div className="cardName">{name}</div>
            {this.renderAssignmentControls()}
          </div>
          {isTimeBased && (
            <div className="timeBasedLabel hideOnScroll">
              <Icon className="timeBasedIcon" icon="access-time" fill="#8392a7" size="20px" />
              <span>This lesson has time-based completion enabled.</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}
